import { SET_PRODUCTS } from './productsActions';
import defaultState from './productsDefaultState';
import { Products } from './productsTypes';
import { Action } from '../../generalTypes';

export default (
  state: Products = defaultState,
  action: Action<Products>
): Products => {
  switch (action.type) {
    case SET_PRODUCTS:
      return [...state, ...action.payload];
    default:
      return state;
  }
};
